import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatHeading(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M6 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-4h4v4a1 1 0 1 0 2 0V7a1 1 0 1 0-2 0v4H7V7a1 1 0 0 0-1-1ZM15 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V8h-1a1 1 0 0 1-1-1Z"
      />
    </BaseIcon>
  );
}
